import { FC, ReactNode } from 'react';

import Text from 'components/_core/Text';

import { Contact } from '../../../../types';
import locales from './locales';

interface ContactsInfoLineProps {
  contacts: Contact[];
  onContactClick: (contact: Contact) => void;
}

const ContactsInfoLine: FC<ContactsInfoLineProps> = ({
  contacts,
  onContactClick,
}) => (
  <>
    {contacts.length < 1 ? (
      <Text variant="primary">{locales.formatString(locales.noContact)}</Text>
    ) : null}

    {contacts.length
      ? contacts
          .map<ReactNode>((contact) => (
            <Text
              _hover={{
                textDecoration: 'underline',
              }}
              cursor="pointer"
              fontWeight="weight-500"
              key={contact.clientContactId}
              onClick={() => onContactClick(contact)}
              variant="primary"
            >{`${contact.firstName} ${contact.lastName}`}</Text>
          ))
          .reduce((prev, curr) => [prev, ', ', curr])
      : null}
  </>
);

export default ContactsInfoLine;
